import React from 'react'
import Navbar from '../components/Landing/Navbar'
import { Marquee } from '../components/Landing/Marquee'
import { HeroSection } from '../components/Landing/HeroSection'
import SimpleStep from '../components/Landing/SimpleStep'
import Services from '../components/Landing/Services'
import FAQ from '../components/Landing/FAQ'
import Footer from '../components/Landing/Footer'
import EnquiryForm from '../components/Landing/EnquiryForm'

import CaseLawsSection from '../components/Landing/CaseLawsSection'

const Home = () => {
  return (
    <>
      <Navbar/>
      <Marquee/>
      <HeroSection/>
      <CaseLawsSection/>
      <div className='bg-gradient-to-t from-cyan-100 to-blue-700'>
        <SimpleStep/>
        <Services/>
        <FAQ/>
      </div>
      <Footer/>
      <EnquiryForm />
    </>
  )
}

export default Home

